import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export function SimpleDialog(props) {
  const { onClose, open } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Atenção!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tem certeza que deseja excluir esse registro?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus variant="outlined" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="contained" color="error" onClick={handleClose}>
          Deletar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
